import React from 'react';
import { Button, IconButton, Modal, Fade } from '@mui/material';
import Iframe from 'react-iframe';
import CloseIcon from '@mui/icons-material/Close';
import { makeStyles } from '@mui/styles';
import './waze.css';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  paper: {
    backgroundColor: '#1c2138',
    color: '#fff',
    border: '2px solid #fff',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: '90%',
    height: '90%',
  },
}));

export default function WazeModal() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div id="wazemodal">
      <Button className="maplibregl-ctrl-icon maplibre-ctrl-wazemodal maplibre-ctrl-wazemodal" variant="contained" color="secondary" onClick={handleOpen} alt="Open" />
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <div className="waze-closeButtonDiv">
              <IconButton onClick={handleClose} className="waze-closeButton"><CloseIcon /></IconButton>
            </div>
            <h2>Waze Traffic Events</h2>
            <p className="waze-p">
              <Iframe src="https://embed.waze.com/iframe?zoom=13&lat=25.311209546844445&lon=51.41910552978516" className="waze-iframe" />
            </p>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
